import apiPath from '../../../config/api';

const DailySumPath = {
    title: "Permata- Laporan Rekap Penjualan",
    basePath: "/permata/rekap-penjualan",
    base: apiPath.retailDailySum,
}

export default DailySumPath;
